import {useEffect, RefObject} from 'react';

type Event = MouseEvent;

const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  state: boolean,
  handler: (event: Event) => void
): void => {
  useEffect(() => {
    const listener = (event: Event) => {
      const element = ref?.current;
      if (
        !element ||
        element.contains((event?.target as Node) || null) ||
        !state
      ) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, state, handler]);
};

export default useOnClickOutside;
